import {http} from './config/config-relation-register'

export default{
    listar:(token)=>{
        return  http.get('grupos-alvos',{
            headers:{
                'Authorization':token
            }
        })
    },
    salvar:(token, item)=>{
        return http.post('grupos-alvos',item,{
            headers:{
                'Authorization':token
            }
        })
    },
    deletar:(token, idItem)=>{
        return http.delete('grupos-alvos/'+idItem,{
            headers:{
                'Authorization':token
            }
        })
    },
    update:(token, item)=>{
        return http.put('grupos-alvos/'+item.id_grupo_alvo,item,{
            headers:{
                'Authorization':token
            }
        })
    }

}